(function() {
  let offsetY = 0;
  const step = 12;        // Smaller step for smoother movement
  const interval = 8000;  // Moves every 150ms for subtle, continuous feel

  function updateBackground(delta = step) {
    offsetY -= delta;  // Subtract instead of add — moves background up
    document.documentElement.style.setProperty('--bg-offset-y', `${offsetY}px`);
  }

  // Slightly larger upward nudge on Add to Cart click
  document.addEventListener('click', function(e) {
    const target = e.target.closest('[type="submit"], .product-form__submit, .add-to-cart, [name="add"]');
    if (target) {
      updateBackground(10); // nudge visibly on user action
    }
  });

  // Smooth auto-scroll upward
  setInterval(() => updateBackground(), interval);
})();
